import { render, staticRenderFns } from "./FormCompanyRole.vue?vue&type=template&id=5fe32ed0"
import script from "./FormCompanyRole.vue?vue&type=script&lang=js"
export * from "./FormCompanyRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports